var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-photo-edit',{attrs:{"photo-url-prop":_vm.photoUrlProp,"image-height":_vm.imageHeight,"image-width":_vm.imageWidth,"save-callback":_vm.saveCallback},on:{"cancel":_vm.onFinished,"save":_vm.onFinished}})
}
var staticRenderFns = []

export { render, staticRenderFns }